import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { PaginatedUsers } from '../../domain/models/user/paginated-users';
import { Observable } from 'rxjs';
import { User } from '../../domain/models/user/user';
import { ChartFileInfo } from '../../domain/models/file/chart-file-info';
import { UserStatus } from '../../domain/models/user/user-status';
import { UserProfile } from '../../domain/enums/user-profile';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly http = inject(HttpClient);
  private baseUrl = environment.apiUrl;

  getUserById(id: string): Observable<User> {
    return this.http.get<User>(`${this.baseUrl}api/users/${id}`);
  }

  getUserFiles(oidcId: string): Observable<ChartFileInfo[]> {
    return this.http.get<ChartFileInfo[]>(
      `${this.baseUrl}api/files/converted-by-user/${oidcId}`,
    );
  }

  updateUserStatus(userId: string) {
    return this.http.patch<UserStatus>(
      this.baseUrl + `api/users/${userId}/status`,
      {},
    );
  }

  getPaginatedUsers(
    page: number,
    pageSize: number,
    search: string,
    sortColumn?: string,
    sortDirection?: 'asc' | 'desc',
    status?: string[],
    profiles?: UserProfile[],
  ) {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());

    if (search) {
      params = params.set('search', search);
    }
    if (sortColumn) {
      params = params.set('sortColumn', sortColumn);
    }
    if (sortDirection) {
      params = params.set('sortDirection', sortDirection);
    }
    if (status && status.length > 0) {
      const filteredStatus = status.filter((s) => s && s.trim() !== '');
      if (filteredStatus.length > 0) {
        params = params.set('status', filteredStatus.join(','));
      }
    }
    if (profiles && profiles.length > 0) {
      const filteredProfiles = profiles.filter((p) => p);
      if (filteredProfiles.length > 0) {
        filteredProfiles.forEach((p) => {
          params = params.append('profiles', p);
        });
      }
    }
    return this.http.get<PaginatedUsers>(
      `${this.baseUrl}api/users/paginated-search`,
      { params },
    );
  }
}
